import { observer } from 'mobx-react-lite'
import moment, { type Moment } from 'moment'
import { useEffect, useState } from 'react'

import { dmsState } from '@/app/store'
import { type IPostSpecialConditionDto, type ISpecialCondition } from '@/app/types/dmsTypes'
import { type TextAreaEvent } from '@/pages/Dms/helper'

import style from './InsuredSpecialConditions.module.scss'
import { Item } from './Item/Item'
import { NewItem } from './NewItem/NewItem'

interface IProps {
    showDescription: boolean
    specialConditions: ISpecialCondition[]
    polisId: string
    insuranceProgramId: string
}

export const InsuredSpecialConditions = observer((props: IProps) => {
    const { showDescription, specialConditions, polisId, insuranceProgramId } = props

    const [newCondition, setNewCondition] = useState<IPostSpecialConditionDto | null>(null)
    const [sconditionsList, setSconditionsList] = useState<ISpecialCondition[]>(specialConditions)

    useEffect(() => {
        setSconditionsList(specialConditions)
    }, [specialConditions])

    const onAddNewSpecialCondition = () => {
        setNewCondition({
            polisId,
            insuranceProgramId,
            startedAt: moment().format(),
            finishedAt: moment().format(),
            description: ''
        })
    }
    const onChangeNewStartedAt = (e: Moment) => {
        setNewCondition({
            polisId,
            insuranceProgramId,
            startedAt: moment(e).format(),
            finishedAt: newCondition ? newCondition.finishedAt : '',
            description: newCondition ? newCondition.description : ''
        })
    }
    const onChangeNewFinishedAt = (e: Moment) => {
        setNewCondition({
            polisId,
            insuranceProgramId,
            startedAt: newCondition ? newCondition.startedAt : '',
            finishedAt: moment(e).format(),
            description: newCondition ? newCondition.description : ''
        })
    }
    const onChangeSpecialConditionsDescription = (e: TextAreaEvent) => {
        if (newCondition) {
            setNewCondition({
                polisId,
                insuranceProgramId,
                startedAt: newCondition ? newCondition.startedAt : '',
                finishedAt: newCondition ? newCondition.finishedAt : '',
                description: e.target.value
            })
        }
    }
    const onPostNewSpecialCondition = () => {
        if (newCondition) {
            const startedAt = moment(newCondition.startedAt).format('YYYY-MM-DDT00:00:00+00:00')
            const finishedAt = moment(newCondition.finishedAt).format('YYYY-MM-DDT23:59:59+00:00')
            const description = newCondition.description
            dmsState.onPostSpecialCondition(
                {
                    polisId,
                    insuranceProgramId,
                    description: newCondition.description,
                    startedAt,
                    finishedAt
                },
                (id: string) => {
                    setSconditionsList((prev) => [
                        ...prev,
                        {
                            dateRanges: [
                                {
                                    startedAt,
                                    finishedAt
                                }
                            ],
                            descriptions: description,
                            id
                        }
                    ])
                    setNewCondition(null)
                }
            )
        }
    }

    return (
        <div className={style.container}>
            {newCondition && (
                <NewItem
                    name={'Новое расширение'}
                    description={newCondition.description}
                    startedAt={moment(newCondition.startedAt)}
                    finishedAt={moment(newCondition.finishedAt)}
                    onCancel={() => setNewCondition(null)}
                    onChangeNewFinishedAt={onChangeNewFinishedAt}
                    onChangeNewStartedAt={onChangeNewStartedAt}
                    onPostNewSpecialCondition={onPostNewSpecialCondition}
                    onChangeSpecialConditionsDescription={onChangeSpecialConditionsDescription}
                />
            )}
            {sconditionsList.length > 0 ? (
                sconditionsList.map((condition, idx) => (
                    <Item
                        key={condition.id}
                        showProgramDescription={showDescription}
                        insuranceProgramId={insuranceProgramId}
                        name={`Расширение #${idx + 1}`}
                        polisId={polisId}
                        setSconditionsList={setSconditionsList}
                        {...condition}
                    />
                ))
            ) : (
                <div className={style.emptySpecialConditions}>
                    <span>Расширения отсутствуют</span>
                </div>
            )}
            <button disabled={!!newCondition} className={style.addBtn} onClick={onAddNewSpecialCondition}>
                Добавить расширение
            </button>
        </div>
    )
})
